import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { useNavigate } from "react-router-dom";
import envConfig from "../config.json";
import { Progress, Spin } from "antd";
import NavigationMessage from "../components/NavigationMessage";
import { useTheme } from "../components/ThemeContext";

/**
 * Component used to handle model builder functionality
 */
const Builder = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const navigate = useNavigate();
  const { theme} = useTheme();
  const {
    unityProvider,
    isLoaded,
    loadingProgression,
    sendMessage,
    unload,
    addEventListener,
  } = useUnityContext({
    loaderUrl: "plantlayout/Build/plantlayout.loader.js",
    dataUrl: "plantlayout/Build/plantlayout.data",
    frameworkUrl: "plantlayout/Build/plantlayout.framework.js",
    codeUrl: "plantlayout/Build/plantlayout.wasm",
  });
  const msalToken = localStorage.getItem("msal.accesstoken");
  const Token3DCE = localStorage.getItem("accesstokence");
  const sasToken = localStorage.getItem("sasToken");
  const loadingPercentage = Math.round(loadingProgression * 100);

  /**
   * Function to used get the token
   */
  const getCdfToken = () => {
    const unityObj = {
      env: envConfig.env,
      middleware_base_url: envConfig.aotmwapi,
      access_token_3dce:
        envConfig.application_type === "couple" ? Token3DCE : "",
      msal_token: msalToken,
      cognite_ah_rootnode: envConfig.cognite_ah_rootnode,
      sas_token: sasToken,
      theme:theme
    };
    console.log({ unityObj });
    const unityJson = JSON.stringify(unityObj);
    sendMessage("HtmlUnityBridge", "OnConfigurationReceived", unityJson);
    setLoading(false);
  };
  /**
   * Function to handle click
   */
  const handleClick = async (evt) => {
    try {
      await unload();
      navigate(evt.detail.pathName, { replace: true });
    } catch (error) {
      console.log({ error });
    }
  };
  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (isLoaded) {
      setLoading(true);
      getCdfToken();
    }
    addEventListener("raiseEventFromUnity", function (arg1, arg2) {
      if (arg1 === "Unauthorized") {
        console.log("AuthenticationFailLogOut");
        localStorage.removeItem("checkRole");
        const logoutRequest = {
          postLogoutRedirectUri: envConfig.redirectUri,
        };
        instance.logoutRedirect(logoutRequest);
      }
    });
    window.addEventListener("/plant", (evt) => {
      handleClick(evt);
    });
    const handleWindowResize = () => {
      const widthreduced = (window.innerWidth / 100) * 5;
      setWindowWidth(window.innerWidth - widthreduced);
    };
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);


    const setWebGLTheme = () => {
      const theme=localStorage.getItem("TwinBuilder3DTheme");
    sendMessage("HtmlUnityBridge", "OnThemeChange",theme);
    };
    window.addEventListener("SetWebGLTheme", setWebGLTheme);
    
    
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("SetWebGLTheme", setWebGLTheme);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, loadingPercentage, addEventListener]);

  return (
    <div id="containerFixed">
      {!isLoaded ? (
        <>
          <Progress
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#87d068",
            }}
            percent={loadingProgression * 100}
            showInfo={false}
          />
          <NavigationMessage></NavigationMessage>
        </>
      ) : null}
      <div id="unity-container" className="unity-desktop">
        <Unity
          unityProvider={unityProvider}
          style={{
            visibility: isLoaded ? "visible" : "hidden",
            width: `${windowWidth}px`,
            height: "calc(100vh - 85px)",
            marginTop: "-75px",
          }}
          tabIndex={0}
          devicePixelRatio={devicePixelRatio}
        />
      </div>
      {loading ? (
        <div className="centerPage">
          <div className="divAlignCenter">
            <Spin>
              <p>Loading</p>{" "}
            </Spin>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Builder;
